export enum EstateApplicationStageType {
  EXPIRED = 'EXPIRED',
  PRISTINE = 'PRISTINE',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PRE_APPROVED = 'PRE_APPROVED',
}
